import AppInput from '@nxsys/components/AppInputSearch';
import AppMenuFilter from '@nxsys/components/AppMenuFilter';
import { AppState } from '@nxsys/store';
import { GetInvoiceListParams } from '@nxsys/types/api';
import { debounce } from 'lodash';
import { useCallback, useState } from 'react';
import { useSelector } from 'react-redux';
import AgencyFilterModal from './AgencyFilterModal';
import FilterModal from './FilterModal';
import { useTypedIntl } from '@nxsys/hooks/useTypedIntl';
import { InvoiceTypeEnum } from '@nxsys/constants/AppEnums';

type ActionsHeaderProps = {
  onSearch: (value: string) => void;
  onFilter: (params: GetInvoiceListParams) => void;
  invoiceType?: InvoiceTypeEnum;
};

export const ActionsHeader = ({
  onSearch,
  onFilter,
  invoiceType,
}: ActionsHeaderProps) => {
  const { messages } = useTypedIntl();
  const { isAgency } = useSelector((state: AppState) => state.appStore);

  const [openFilter, setOpenFilter] = useState(false);

  const [searchValue, setSearchValue] = useState('');

  const toggleFilter = () => {
    setOpenFilter(!openFilter);
  };

  const debouncedFetchData = useCallback(
    debounce((search: string) => {
      onSearch(search);
    }, 500),
    [onSearch],
  );

  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    setSearchValue(value);
    debouncedFetchData(value);
  };

  return (
    <div className="flex items-center gap-2 w-full">
      <AppInput value={searchValue} onChange={handleSearchChange} />
      <AppMenuFilter options={[]} onChange={() => {}} onClick={toggleFilter} />
      {isAgency ? (
        <AgencyFilterModal
          isOpen={openFilter}
          toggle={toggleFilter}
          title={messages['common.filter']}
          onFilter={onFilter}
          invoiceType={invoiceType}
        />
      ) : (
        <FilterModal
          isOpen={openFilter}
          toggle={toggleFilter}
          title={messages['common.filter']}
          onFilter={onFilter}
          invoiceType={invoiceType}
        />
      )}
    </div>
  );
};
